import { render } from "./Meeting.vue?vue&type=template&id=0cba1231&scoped=true"
import script from "./Meeting.vue?vue&type=script&lang=js"
export * from "./Meeting.vue?vue&type=script&lang=js"

import "./Meeting.vue?vue&type=style&index=0&id=0cba1231&lang=scss&scoped=true"

import exportComponent from "/home/controlcenter/sourcecode/dubiverse/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cba1231"]])

export default __exports__